import type { ReactNode } from "react";

import type { FeatureKey } from "./config";

import { useRoleAccess } from "./useRoleAccess";

type FeatureGuardProps = {
  children: ReactNode;
  fallback?: ReactNode;
  feature: FeatureKey;
};

export function FeatureGuard({
  children,
  fallback = null,
  feature,
}: FeatureGuardProps): ReactNode {
  const { canAccess } = useRoleAccess();

  return canAccess(feature) ? <>{children}</> : <>{fallback}</>;
}
